var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { Button, Form, Grid, Icon, Select } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { HcrAmplifier } from "../automated-pro/RnaCatalog";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
var AutomatedIfEncoderForm = /** @class */ (function (_super) {
    __extends(AutomatedIfEncoderForm, _super);
    function AutomatedIfEncoderForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editing: false
        };
        _this.onClearAllSpecies = function () {
            _this.props.onEncoderChange(function () { return ({ primarySpeciesIds: [] }); }, _this.props.onUserSelection);
        };
        _this.onEditClick = function () {
            _this.setState({ editing: true });
        };
        _this.onEditDone = function () {
            _this.setState({ editing: false });
        };
        _this.onAmplifierChange = function (i) { return function (_, data) {
            var newPairs = __spreadArrays(_this.props.currentAmpLabelPairs);
            newPairs[i] = __assign(__assign({}, newPairs[i]), { hcrAmplifier: new HcrAmplifier(data.value) });
            var snapCooledConfigId = resolveSnapCooledConfigId(newPairs, _this.props.catalog.automatedIfDetect);
            _this.props.onAmpConfigChange(newPairs, snapCooledConfigId);
        }; };
        _this.onPrimarySpeciesChange = function (i) { return function (_, data) {
            var species = _this.props.catalog.encoder.primarySpecies.find(function (p) { return p.id === data.value; });
            if (species === undefined) {
                throw new RangeError("Could not find species " + data.value);
            }
            // autopopulate all species if we're adding the first species to the list
            var newIds = __spreadArrays(_this.props.encoderState.primarySpeciesIds);
            if (_this.props.encoderState.primarySpeciesIds.length === 0) {
                for (var j = 0; j < _this.props.plexity; j++) {
                    newIds[j] = species.id;
                }
            }
            else {
                newIds[i] = species.id;
            }
            _this.props.onEncoderChange(function () { return ({ primarySpeciesIds: newIds }); }, _this.props.onUserSelection);
        }; };
        _this.onEncoderScaleUlChange = function (event) {
            var val = parseFloat(event.currentTarget.value);
            _this.props.onEncoderChange(function () { return ({ encoderScaleUl: isNaN(val) ? 0 : val }); });
        };
        _this.onAntibodyBlockMlChange = function (event) {
            var val = parseFloat(event.currentTarget.value);
            _this.props.onEncoderChange(function () { return ({ antibodyBlockMl: isNaN(val) ? 0 : val }); });
        };
        _this.onAntibodyDiluentMlChange = function (event) {
            var val = parseFloat(event.currentTarget.value);
            _this.props.onEncoderChange(function () { return ({ antibodyDiluentMl: isNaN(val) ? 0 : val }); });
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onEncoderChange(function (oldState) { return ({
                customPrice: newStateFn(oldState.customPrice)
            }); }, callback);
        };
        return _this;
    }
    AutomatedIfEncoderForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, plexity = _a.plexity, catalog = _a.catalog, encoderState = _a.encoderState, errors = _a.errors, showErrors = _a.showErrors, enableCustomPrice = _a.enableCustomPrice, effectivePriceCents = _a.effectivePriceCents, listPriceCents = _a.listPriceCents, priceLoading = _a.priceLoading, scalesReadOnly = _a.scalesReadOnly, ampConfigEditable = _a.ampConfigEditable, currentAmpLabelPairs = _a.currentAmpLabelPairs;
        var allSpeciesOptions = catalog.encoder.primarySpecies.map(function (p) { return ({
            text: p.displayName,
            value: p.id
        }); });
        var allAmplifiers = catalog.automatedIfCustomAmplifiers;
        var chunks = [];
        var _loop_1 = function (k) {
            chunks.push(Array.from({ length: Math.min(4, plexity - k) }, function (_, j) { return k + j; }));
        };
        for (var k = 0; k < plexity; k += 4) {
            _loop_1(k);
        }
        return React.createElement(Grid, { columns: 4, stackable: true },
            chunks.map(function (chunkIndices, chunkIdx) { return (React.createElement(Grid.Row, { key: chunkIdx }, chunkIndices.map(function (i) {
                var _a, _b, _c;
                var channel = currentAmpLabelPairs[i];
                return React.createElement(Grid.Column, { key: (_a = channel === null || channel === void 0 ? void 0 : channel.channel) !== null && _a !== void 0 ? _a : i },
                    React.createElement(FieldWithErrorDisplay, { errorPath: "/encoderComponent/encoderAmpPairs/" + i + "/primarySpecies", errors: errors, labelContent: "Channel " + ((_b = channel === null || channel === void 0 ? void 0 : channel.channel) !== null && _b !== void 0 ? _b : (i + 1)), labelFor: "primarySpecies-" + i, showErrors: showErrors },
                        React.createElement(Select, { name: "primarySpecies-" + i, options: allSpeciesOptions, onChange: _this.onPrimarySpeciesChange(i), placeholder: 'Select species...', search: true, value: (_c = encoderState.primarySpeciesIds[i]) !== null && _c !== void 0 ? _c : '' })),
                    channel && React.createElement("div", { className: 'encoder-amp-badge' },
                        React.createElement("span", null,
                            "HCR\u2122 Amplifier: ",
                            channel.hcrAmplifier.id),
                        ampConfigEditable && i === 0 && React.createElement(Button, { basic: true, compact: true, size: 'mini', icon: true, type: 'button', onClick: _this.onEditClick },
                            React.createElement(Icon, { name: 'pencil' }))));
            }))); }),
            encoderState.primarySpeciesIds.some(Boolean) && (React.createElement(Grid.Row, { style: { paddingTop: 0 } },
                React.createElement(Grid.Column, { width: 16, textAlign: 'right' },
                    React.createElement(Button, { compact: true, size: 'small', type: 'button', color: 'red', basic: true, onClick: this.onClearAllSpecies },
                        React.createElement(Icon, { name: 'times circle' }),
                        "Clear all species")))),
            this.state.editing && (React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement("div", { className: 'amp-label-editor amp-label-editor--two-col' }, currentAmpLabelPairs.map(function (pair, i) {
                        var usedAmplifiers = new Set(currentAmpLabelPairs
                            .filter(function (_, j) { return j !== i; })
                            .map(function (p) { return p.hcrAmplifier.id; }));
                        return React.createElement(React.Fragment, { key: i },
                            React.createElement("span", { className: 'amp-label-editor-channel' },
                                "Channel ",
                                pair.channel),
                            React.createElement(FieldWithErrorDisplay, { labelContent: 'HCR™ Amplifier', errors: errors, errorPath: "/encoderComponent/encoderAmpPairs/" + i + "/hcrAmplifierId", showErrors: showErrors },
                                React.createElement(Select, { options: allAmplifiers.map(function (a) { return ({ text: a.id, value: a.id, disabled: usedAmplifiers.has(a.id) }); }), value: pair.hcrAmplifier.id, onChange: _this.onAmplifierChange(i) })));
                    })),
                    React.createElement(Button, { type: 'button', onClick: this.onEditDone, style: { marginTop: '0.75em' } }, "Done")))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/encoderComponent/encoderScaleUl', errors: errors, labelContent: 'Encoder scale (µL)', labelFor: 'encoderScaleUl', showErrors: showErrors },
                        React.createElement(Form.Input, { name: 'encoderScaleUl', type: 'number', value: encoderState.encoderScaleUl, onChange: this.onEncoderScaleUlChange, onBlur: this.props.onUserSelection, disabled: scalesReadOnly }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/encoderComponent/antibodyBlockMl', errors: errors, labelContent: 'Antibody block (mL)', labelFor: 'antibodyBlockMl', showErrors: showErrors },
                        React.createElement(Form.Input, { name: 'antibodyBlockMl', type: 'number', value: encoderState.antibodyBlockMl, onChange: this.onAntibodyBlockMlChange, onBlur: this.props.onUserSelection, disabled: scalesReadOnly }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/encoderComponent/antibodyDiluentMl', errors: errors, labelContent: 'Antibody diluent (mL)', labelFor: 'antibodyDiluentMl', showErrors: showErrors },
                        React.createElement(Form.Input, { name: 'antibodyDiluentMl', type: 'number', value: encoderState.antibodyDiluentMl, onChange: this.onAntibodyDiluentMlChange, onBlur: this.props.onUserSelection, disabled: scalesReadOnly }))),
                priceColumn(React.createElement(ComponentPriceDisplay, { loading: priceLoading, effectivePriceCents: effectivePriceCents, listPriceCents: listPriceCents }), effectivePriceCents !== listPriceCents)),
            enableCustomPrice &&
                React.createElement(React.Fragment, null,
                    React.createElement(CustomPriceRow, { customPrice: encoderState.customPrice, defaultEffectivePriceCents: effectivePriceCents, errors: errors, errorPathPrefix: '/encoderComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })));
    };
    return AutomatedIfEncoderForm;
}(React.Component));
export default AutomatedIfEncoderForm;
var resolveSnapCooledConfigId = function (pairs, catalog) { var _a, _b; return (_b = (_a = catalog.configs.find(function (config) {
    return pairs.length === config.channels.length &&
        pairs.every(function (pair) {
            return config.channels.some(function (ch) {
                return ch.hcrAmplifier.id === pair.hcrAmplifier.id &&
                    ch.fluorophore.id === pair.fluorophore.id &&
                    ch.channel === pair.channel;
            });
        });
})) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1; };
//# sourceMappingURL=AutomatedIfEncoderForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-gold-if/AutomatedIfEncoderForm.js
// module id = 1145
// module chunks = 0